import context from '@truckdown/components-systems';
import { defineComponent, ref, Ref, onMounted, watch, computed } from "vue";
import { FindLocationsUsingAccounts, ILocationQueryService, LocationModel } from '@truckdown/locations';

interface IData {
    locationList: Ref<ISelectItem[]>,
    locationListUnfiltered: Ref<ISelectItem[]>,
    selectedLocation: Ref<ISelectItem | null>,
    showLocationList: Ref<boolean>,
    searchTermLocation: Ref<string>,
};

export interface ISelectItem {
    value: string,
    display: string,
    terms?: string
};

const getInitialData = function (props: any) {
    return {
        locationList: ref<ISelectItem[]>([]),
        locationListUnfiltered: ref<ISelectItem[]>([]),
        selectedLocation: ref<ISelectItem | null>(null),
        showLocationList: ref<boolean>(false),
        searchTermLocation: ref<string>(""),
    }
};

const getComputed = function (data: IData, props: IProps) {
    return {
        locationList: computed(() => {
            let base = data.locationListUnfiltered.value;

            if (props.selectedLocations) {
                base = data.locationListUnfiltered.value
                    .filter(l => props.selectedLocations.indexOf(l.value) < 0);
            }

            var term = data.searchTermLocation.value.trim();
            if (term.length == 0) {
                return base;
            } else {
                return base.filter((v) => {
                    return v.display.toLowerCase().indexOf(term.toLowerCase()) >= 0;
                });
            }
        }),
        isShowResults: computed(() => {
            return (data.showLocationList.value && data.locationList.value.length > 0);
        })
    }
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        selectLocation: function (location?: ISelectItem) {
            if (location) {
                let index = null;
                if (props.index != undefined || props.index != null) {
                    index = props.index
                }

                data.selectedLocation.value = location;
                ctx.emit('select-location', location);
            }
            data.searchTermLocation.value = "";
        }
    }
}

const getLocations = async function (data: IData, accId: string) {
    let mgr = await context.getService<ILocationQueryService>('ILocationQueryService');
    await mgr.findLocations({
        accountIds: [accId],
        tags: ['#active', "#loc-paid"],
        limit: 10000
    } as FindLocationsUsingAccounts)
        .then((res) => {
            data.locationListUnfiltered.value = res.results.map(r => ({
                value: r.id,
                display: `${r.name} - ${r.address.city},  ${r.address.regionCode}`,
                terms: r.locationId.toString()
            })).sort((a, b) => {
                if (a.display < b.display) {
                    return -1;
                }
                if (a.display > b.display) {
                    return 1;
                }
                return 0;
            });
        })
        .catch((reason) => {
            console.log(reason);
        });
}

interface IProps {
    accountId?: string;
    hideLabel: boolean;
    isError: boolean;
    selectedLocations: string[];
}

export default defineComponent({
    name: "LocationLookup",
    props: {
        accountId: {
            type: String,
            required: false
        },
        hideLabel: {
            type: Boolean,
            required: false
        },
        isError: {
            type: Boolean,
            required: false
        },
        selectedLocations: {
            type: Array as () => string[],
            required: true
        }
    },
    emits: ['select-location'],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let computed = getComputed(data, props);
        let methods = getMethods(props, data, ctx);

        onMounted(async () => {
            await getLocations(data, props.accountId || "");
        });

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});


